export enum KeyCode {
    Enter = 'Enter'
}
